// Clinic Configuration for Todays Dental Alexandria
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Todays Dental Alexandria",
  clinicId: "todaysdentalalexandria",
  clinicUrl: "https://todaysdentalalexandria.com",
  // Contact Information
  phoneNumber: "703-256-2085",
  phoneNumberRaw: "+17032562085", // For tel: and sms: links
  email: "Dentist@TodaysDentalAlexandria.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=todaysdentalalexandria&agentId=bed7df77-47c9-44c5-9815-12fe976801b4",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/todaysdentalalexandria/voice",

  // Location
  address: "4601 Pinecrest Office Park Dr Ste D, Alexandria, VA 22312, USA",
  addressShort: "4601 Pinecrest Office Park Dr Ste D, Alexandria, VA 22312",
  city: "Alexandria",
  hcity: "Alexandria",
  state: "Virginia",
  stateShortForm: "VA",
  PostalCode: "22312",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/vqABURPKCfMrFuuX9",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2986.9392453941764!2d-77.16292092406674!3d38.82422597173971!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b361217c984d%3A0xda10715b4d2829e1!2sTodays%20Dental%20%40%20Alexandria!5e1!3m2!1sen!2sin!4v1759834959945!5m2!1sen!2sin',
  iframeTitle: "Todays Dental Alexandria",

  //membership
  membership: "https://member.kleer.com/?slug=VD9L",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/TodaysDentalatAlexandria",

  // Cherry
  cherryUrl: "https://todaysdentalalexandria.com/patient-portal",

  // Analytics
  clarityProjectId: "prcjdqxsau",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/todaysdentalalexandria",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/todaysdentalalexandria",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/todaysdentalalexandria",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://todaysdentalalexandria.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61560361593741#",
    instagram: "https://www.instagram.com/stories/todaysdentalalexandria/",
    twitter: "https://x.com/td_alexandria",
    linkedin: "https://www.linkedin.com/company/108152265/admin/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BZHzZHS4UQLaEyel%2BGoze8g%3D%3D",
    youtube: "https://www.youtube.com/@todaysdentalalexandria",
  },

  // Open Dental Configuration
  defaultProvNum: 6,
  defaultOpNum: 17,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 16,
      AppointmentTypeNum: 12
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 17,
      AppointmentTypeNum: 13
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 17,
      AppointmentTypeNum: 16
    }
  ],




  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:${this.phoneNumberRaw}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;
